/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUsersKey: {
  name: 'users-key';
  data: string;
} = {
  name: 'users-key',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4 8a5 5 0 0 0-5 5 1 1 0 1 1-2 0 7 7 0 1 1 14 0 1 1 0 1 1-2 0 5 5 0 0 0-5-5Zm9.353-8.646L16.707 8l.647.646a.5.5 0 0 1-.708.708L16 8.707l-.146.147a.5.5 0 0 1-.708-.708l.5-.5 2-2a1.5 1.5 0 1 1 .707.707ZM18.5 5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z" fill="currentColor"/></svg>`,
};
